import * as React from 'react';
import { FieldArray } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import type { PermitsOwnProps } from './Permits';
import Permits from './Permits';
import JobUpsertFM from '../../../formModel';
import { formSectionClass } from '../../../helpers';

interface OwnProps {
	isDisabled: boolean;
}

type Props = OwnProps;

const PermitsRequiredSection: React.FC<Props> = (props) => {
	const { isDisabled } = props;
	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Permits Required"
				tooltip="All permits and authorizations necessary for the legal execution of this job."
			/>
			<div className="m-b-m" />
			<FieldArray<PermitsOwnProps>
				component={Permits}
				isDisabled={isDisabled}
				name={JobUpsertFM.getAttributeName('permitsRequired')}
			/>
		</div>
	);
};

export default PermitsRequiredSection;
